import { render, staticRenderFns } from "./SuperZones.vue?vue&type=template&id=72714f61"
import script from "./SuperZones.vue?vue&type=script&lang=js"
export * from "./SuperZones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports